import I18nPlugin from './advanced';
export * from './advanced/MessageFormatter';
export * from './advanced/install';
export * from './advanced/service';
export * from './advanced/util';
export * from './advanced/create';

export default I18nPlugin;
